import { Badge } from 'framework/ui/mui-builder';

const VendorCompliantBadge = ({ isCompliant }: { isCompliant: boolean }) => (
  <Badge id="isCompliant" color={isCompliant ? 'success' : 'warning'}>
    {isCompliant ? 'Compliant' : 'Not compliant'}
  </Badge>
);

export default VendorCompliantBadge;
